export const ProjectData=[
    
    {
        id:1,
        title:"Messenger Client-Server App",
        about:"This is a fully implemented messaging app that has a Windows Forms front-end built on Visual Studio. It uses a C++ backend server running on a different host to manage the chats. There are multiple chatrooms and the server uses semaphores and blocking to ensure smooth message delivery across multiple chat rooms.",
        tags:["C++","C#","Visual Studio"],
        //demo:'www.demolink.com',
        github:'https://github.com/nipunaprs/chat-application',
        image: "/Screenshot_3.jpg",
        youtube: "https://www.youtube.com/watch?v=YRhnrcTj7aM",
        type: ["other"]
    },
    {
        id:2,
        title:"Gaming Branch Management Software",
        about:"A full-stack branch management application for a video game store. This project was built using a React front-end, Express backend, and a MySQL database. Functionalities include the ability to insert new employees, ads, or stock. The view displays multiple complex queries. Recommendation uses previous data to sell new games. Finally, accounting functionality displays useful branch revenue details.",
        tags:["ReactJS","MySQL","Express"],
        //demo:'www.demolink.com',
        github:'https://github.com/nipunaprs/GameStore.git',
        image: "/bigbase.gif",
        youtube: "https://www.youtube.com/watch?v=ANygPu4Hiwc",
        type: ["fullstack"]
    },
    {
        id:3,
        title:"C# Trading Orderbook",
        about:"Implemented the base structure for a C# based orderbook which handles order buy, sell side limit orders for instruments. The code uses several .NET libraries including Microsoft Hosting and Logging libraries. The project helped serve as an introduction to quantitative programming and provide a base understanding of financial market engineering.",
        tags:["C#",".NET 2.0"],
        //demo:'www.demolink.com',
        github:'https://github.com/nipunaprs/TradingEngine',
        image: "/trading.jpg",
        //youtube: "https://www.youtube.com/watch?v=vlxcb33XPr4",
        type: ["other"]
    },
    {
        id:4,
        title:"Spacestagram - Space IG Clone",
        about:"A web-based space themed social media app built on React using NASA's APOD API. The images are automatically updated based on the current date and older images are moved down chronologically. Functionality includes ability to filter images based on specific date range, like and unlike as well as request further information.",
        tags:["ReactJS","NASA API"],
        demo:'https://spacestagrams.netlify.app/',
        github:'https://github.com/nipunaprs/Spacesgram',
        image: "/spacestagram.gif",
        youtube: "https://www.youtube.com/watch?v=LcuwUZDjF4k",
        type: ["fullstack"]
    },
    {
        id:5,
        title:"TravelnGo! - Personalized Travel Advisor",
        about:"A web-based complete interactive travel advisor application that is built on React and uses multiple GoogleMapsAPI and TravelAdvisor RapidAPI to recommend great restaurants, attractions, and hotels to users. The website is fully dynamic/responsive and allows users to sort different places based on their ratings. It also displays useful information such as any awards recieved, star ranking, address, and more.",
        tags:["ReactJS","JSX","GoogleMapAPI","RapidAPI"],
        demo:'https://travel-n-go.netlify.app/',
        github:'https://github.com/nipunaprs/travelngo',
        image: "/travelngo.gif",
        youtube: "https://www.youtube.com/watch?v=gMb2xlvhF5U",
        type: ["fullstack"]
    },
    {
        id:6,
        title:"FormCheck - AI Gym Assistant",
        about:"For final year Capstone Project, developed a machine learning based Personal AI Gym Assistant application. Developed non-linear ML models using TensorFlow MoveNet to analyze exercise video data. Used random forest regressor model and gradient boosting regressor from SciKit Learn package based on angle data from MoveNet to predict form. Developed valuable user reccomendations based on live analysis of body key points to reduce injury and maximize growth. Watch the breakdown on YouTube!",
        tags:["TensorFlow","Scikit Learn","Python","MatPlotLib"],
        demo:'https://drive.google.com/file/d/19UAOkEoyQJn_8ZaqVf-NBq3OiEB_pNy7/view?usp=share_link',
        github:'https://github.com/nipunaprs/travelngo',
        image: "/formcheck.gif",
        youtube: "https://www.youtube.com/watch?v=k6BvWMPDjgU",
        type: ["fullstack","ml"]
    },
    {
        id:7,
        title:"Python Graphics Apps",
        about:"Utilized OpenGL and Python to implement a variety of mathematical functions such as gerstner waves, and marching cubes algorithmn with OpenGL libraries. Utilized numpy, linear algebra and OpenGL shader language to turn math into 3D interactive applications.",
        tags:["Python","OpenGL","NumPy","Linear Algebra"],
        //demo:'www.demolink.com',
        //github:'https://github.com/nipunaprs/chat-application',
        image: "/graphics.gif",
        youtube: "https://www.youtube.com/watch?v=hSg4CT5-wm4",
        type: ["gaming"]
    },
    {
        id:8,
        title:"Game Development (3D/2D)",
        about:"Built multiple 2D & 3D games on Unity and C#. Utilized game design principles and C# scripting to release multiple finished games with full characters, storylines and effects. View video to see showcase!",
        tags:["Unity","C#","Blender"],
        //demo:'www.demolink.com',
        //github:'https://github.com/nipunaprs/chat-application',
        image: "/game.png",
        youtube: "https://youtu.be/jQrTa0o8MTg",
        type: ["gaming"]
    },
    {
        id:9,
        title:"Real Estate Propery Chatbot",
        about:"Built a NLU and GenAI hybrid chatbot to answer questions on properties found in a SQL database utilizing NLP framework RASA, and LangChain with a RAG architechture powered by OpenAI GPT models.",
        tags:["Rasa","LangChain","OpenAI"],
        //demo:'www.demolink.com',
        //github:'https://github.com/nipunaprs/chat-application',
        image: "/realestate.jpeg",
        youtube: "https://www.youtube.com/watch?v=4tibER0bRwE",
        type: ["chatbot"]
    },
    {
        id:10,
        title:"Medical Documentation AI Chatbot (Client Project)",
        about:"Build and deployed a production AI chatbot RAG application with a complex RAG pipeline of 40 unstructed PDFs. Custom made front-end with ReactJS and Tailwind, with a back-end Flask server to manage authentication, chat context and AI functionality.",
        tags:["ReactJS","TailwindCSS","SQLite","Flask","Llama Index","OpenAI", "PineCone"],
        //demo:'www.demolink.com',
        //github:'https://github.com/nipunaprs/chat-application',
        image: "/medical.png",
        youtube: "https://www.youtube.com/watch?v=TOeAe8KB68E&t=46s",
        type: ["ml","chatbot","fullstack"]
    },
    {
        id:11,
        title:"CharacterAI – Roleplay with LLMs SaaS",
        about:"Building a custom SaaS application for AI-driven roleplay chats using open-source and fine-tuned LLM models hosted on third-party cloud platforms. Creating a responsive, performant front-end experience with TypeScript, ReactJS, TailwindCSS, ShadCN, and ReactQuery to deliver a seamless chat experience. Implementing a robust backend with FastAPI to build asynchronous RESTful APIs for seamless integration with Supabase and various LLM providers.",
        tags:["ReactJS","Express","TailwindCSS","PostgreSQL","Supabase","Redux","React-Query", "Finetune Llama3"],
        //demo:'www.demolink.com',
        //github:'https://github.com/nipunaprs/chat-application',
        // image: "/medical.png",
        // youtube: "https://www.youtube.com/watch?v=TOeAe8KB68E&t=46s",
        type: ["ml","fullstack"]
    },
    {
        id:12,
        title:"Personal Development AI Agent",
        about:"An agentic application to help autonomously analyze and provide useful suggestions regarding personal habits using tool connections with Notion and Google Calender. Posting as a series on YouTube.",
        tags:["Python","Flask", "Gemini LLM"],
        //demo:'www.demolink.com',
        //github:'https://github.com/nipunaprs/chat-application',
        image: "/ai-agent-p1.jpg",
        youtube: "https://youtu.be/Hc9hff5i3Mo",
        type: ["fullstack", "ml"]
    },


]